<template>
  <div class="layout">
    <div v-if="!$store.getters['auth/isLoggedIn']">
      <router-view name="login"></router-view>
    </div>
    <Layout v-else>
      <Drawer
        v-model="isExpanded"
        placement="left"
        :closable="false"
        :width="siderWidth"
        :styles="{padding: 0}"
      >
        <Menu active-name="1-2" theme="light" width="auto" class="menu-item">
          <MenuItem name="1-0" to="/profile">
            <Avatar
              icon
              size="large"
              class="ava"
              :style="{ background: color, margin: '0 10px 0 0' }"
            >{{ user.name[0] }}</Avatar>
            <span>
              <div>{{ user.name }}</div>
              <div>
                <small>{{ user.role.name }}</small>
              </div>
            </span>
          </MenuItem>
          <MenuItem
            v-for="(item, index) in menu"
            :key="index"
            :name="'1-' + index + 1"
            :to="item.route"
            @click.native="collapsedSider"
          >
            <Icon :type="item.icon"></Icon>
            <span>{{ item.title }}</span>
          </MenuItem>
        </Menu>
      </Drawer>
      <Layout>
        <Header :style="{
            padding: '0 15px'
          }" class="layout-header-bar">
          <Row>
            <Col :md="1" :xs="2">
              <Icon :class="rotateIcon" type="md-menu" size="24" @click.native="collapsedSider"></Icon>
            </Col>
            <Col span="2" v-if="$mq != 'sm' || ($mq == 'sm' && !isExpanded)">
              <a
                v-if="user.role.type == 'admin'"
                href="https://drive.google.com/drive/folders/1pV_bkx4J6Ir5cYf-huiGuwKzMYXYxub0"
                target="_blank"
                style="font-size: 2em; margin: 0; padding: 0; font-weight: bold;"
              >uMerch</a>
              <h1 v-else>uMerch</h1>
            </Col>
          </Row>
        </Header>
        <Content
          :style="{
            margin: '2px 2px 2px 2px',
            background: '#fff',
            minHeight: '480px',
            maxHeight: '90vh'
          }"
        >
          <router-view></router-view>
        </Content>
      </Layout>
    </Layout>
  </div>
</template>
<script>
// import orderDetail from '@/components/OrderDetail.vue'

export default {
  components: {
    // orderDetail: orderDetail
  },
  data() {
    return {
      isExpanded: false,
      color: '#f56a00',
      adminMenu: [
        {
          title: 'Dashboard',
          route: '/adminDashboard',
          icon: 'md-home'
        },
        {
          title: 'Designs',
          route: '/designs',
          icon: 'ios-shirt'
        },
        {
          title: 'Merch',
          route: '/accounts',
          icon: 'ios-contacts'
        },
        {
          title: 'Users',
          route: '/users',
          icon: 'md-people'
        }
      ],
      designerMenu: [
        {
          title: 'Dashboard',
          route: '/designerdashboard',
          icon: 'md-home'
        },
        {
          title: 'Designs',
          route: '/designs',
          icon: 'ios-shirt'
        }
      ]
    }
  },
  computed: {
    rotateIcon() {
      return ['menu-icon', !this.isExpanded ? 'rotate-icon' : '']
    },
    user() {
      console.debug(
        'authUser from localStorage',
        this.$store.getters['auth/authUser']
      )
      return this.$store.getters['auth/authUser']
    },
    siderWidth() {
      return Math.max(200, Math.ceil(this.user.name.length * 9 + 75))
    },
    menu() {
      if (this.$store.getters['auth/authUser'].role.type == 'admin') {
        return this.adminMenu
      } else {
        return this.designerMenu
      }
    }
  },
  created() {
    this.$store.dispatch('auth/checkAuth')
  },
  methods: {
    collapsedSider() {
      console.log('mq: ', this.$mq)
      this.isExpanded = !this.isExpanded
      // this.$refs.side1.toggleCollapse();
    }
  }
}
</script>
<style scoped>
.layout {
  background: #f5f7f9;
  position: relative;
  border-radius: 4px;
  overflow: auto;
  min-height: 100vh;
  height: 100vh;
}
.layout-header-bar {
  background: #fff;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}
.layout-logo-left {
  width: 90%;
  height: 30px;
  background: #5b6270;
  border-radius: 3px;
  margin: 15px auto;
}
.menu-icon {
  transition: all 0.3s;
}
.rotate-icon {
  transform: rotate(-90deg);
}

.menu-item span {
  display: inline-block;
  overflow: hidden;
  /* width: 69px; */
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
  transition: width 0.2s ease 0.2s;
}
.menu-item i {
  transform: translateX(0px);
  transition: font-size 0.2s ease, transform 0.2s ease;
  vertical-align: middle;
  font-size: 16px;
}
.menu-item .ava {
  transform: translateX(0px);
  transition: font-size 0.2s ease, transform 0.2s ease;
  vertical-align: middle;
  font-size: 16px;
  display: inline-block;
}
/* .ivu-menu-vertical.ivu-menu-light:after {
  display: none;
} */
</style>
<style>
.ivu-table-tbody div {
  font-size: 14px;
  margin-top: 3px;
  margin-bottom: 3px;
}
.ivu-cell-selected {
  font-weight: bold;
}
</style>
